import React from 'react'
import Img from 'gatsby-image'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { rgba, timingFunctions, adjustHue, readableColor } from 'polished'
import { view } from 'react-easy-state'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import { baseStore } from '../../store'

import mq from '../../styles/mq'
import { isEmpty, defaultColor } from '../../utils'
import { infoOverlay, SocLink, HiddenText } from '../elements'

import ComingSoonSvg from '../../images/comingsoon.svg'

@view
export default class Friend extends React.Component {
  renderImage() {
    const { friend } = this.props

    if (friend.featured_media) {
      if (friend.featured_media.localFile.childImageSharp) {
        return (
          <GImg fluid={friend.featured_media.localFile.childImageSharp.fluid} alt={friend.title} />
        )
      }

      if (friend.featured_media.source_url) {
        return <Image src={friend.featured_media.source_url} alt={friend.title} />
      }
    }

    return (
      <ComingSoon>
        <ComingSoonSvg css={{ fill: readableColor(defaultColor(friend.acf.bg_color)) }} />
      </ComingSoon>
    )
  }

  render() {
    const { friend, gap, cellWidth } = this.props

    // if (friend.featured_media.localFile.childImageSharp)
    //   console.log(friend.featured_media.localFile.childImageSharp);

    return (
      <CellWrapper bgColor={defaultColor(friend.acf.bg_color)} gap={gap}>
        <CellInner bgColor={defaultColor(friend.acf.bg_color)} id={friend.id}>
          <ImageWrapper>{this.renderImage()}</ImageWrapper>

          <VertTitle>{friend.title}</VertTitle>

          <Info gap={gap} cellWidth={cellWidth}>
            {!isEmpty(friend.acf.video) && (
              <VideoLink
                href={friend.acf.video}
                target="_blank"
                rel="noopener noreferrer"
                onClick={baseStore.openVideo}
              >
                <i className="fas fa-play" css={{ marginRight: 6 }} />
                Watch Video
              </VideoLink>
            )}

            <Social>
              {!isEmpty(friend.acf.homepage) && (
                <SocLink href={friend.acf.homepage} target="_blank" rel="noopener noreferrer">
                  <i className="fal fa-home" />
                  <HiddenText>Homepage</HiddenText>
                </SocLink>
              )}
              {!isEmpty(friend.acf.facebook) && (
                <SocLink href={friend.acf.facebook} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f" />
                  <HiddenText>Facebook</HiddenText>
                </SocLink>
              )}
              {!isEmpty(friend.acf.instagram) && (
                <SocLink href={friend.acf.instagram} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram" />
                  <HiddenText>Instagram</HiddenText>
                </SocLink>
              )}
              {!isEmpty(friend.acf.twitter) && (
                <SocLink href={friend.acf.twitter} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter" />
                  <HiddenText>Twitter</HiddenText>
                </SocLink>
              )}
              {!isEmpty(friend.acf.youtube_channel) && (
                <SocLink
                  href={friend.acf.youtube_channel}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube" />
                  <HiddenText>YouTube Channel</HiddenText>
                </SocLink>
              )}
            </Social>
            <Title>{friend.title}</Title>
            <Desc>
              <div dangerouslySetInnerHTML={{ __html: friend.content }} />
              {!isEmpty(friend.acf.link) && (
                <OutboundLink href={friend.acf.link} target="_blank" rel="noopener noreferrer">
                  Read more...
                </OutboundLink>
              )}
            </Desc>
          </Info>
        </CellInner>
      </CellWrapper>
    )
  }
}

const CellWrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  position: relative;
  height: 500px;
  overflow: hidden;
  padding: 0 ${p => p.gap}px;
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.4s ease;
`

const imageStyle = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 250px;
  width: 60%;
  width: 80%;
  object-fit: contain;
`

const GImg = styled(Img)`
  ${imageStyle}
`

const Image = props => (
  <div
    css={{
      position: 'relative',
      height: '100%',
    }}
  >
    {/* eslint-disable-next-line */}
    <img
      {...props}
      css={css`
        ${imageStyle}
      `}
    />
  </div>
)

const ComingSoon = styled.div`
  ${imageStyle}
  width: 80%;
  opacity: 0.6;
  ${'' /* mix-blend-mode: overlay; */}

  svg {
    transform-origin: center center;
    transform: rotate(5deg);
    transition: all 0.3s ${timingFunctions('easeInOutQuart')};
  }
`

const VertTitle = styled.h5`
  position: absolute;
  bottom: 0.5rem;
  left: 1rem;
  z-index: 50;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
  text-shadow: 0 0 50px #000, -1px 1px 1px ${rgba('#000', 0.2)};
  transform-origin: top left;
  transform: rotate(-90deg);
  transition: all 0.3s ${timingFunctions('easeInOutQuart')};

  @media (max-width: 480px) {
    display: none;
  }
`

const Info = styled.div`
  ${infoOverlay}
  transition: all 0.6s ${timingFunctions('easeInOutQuart')};

  @media (min-width: 481px) {
    width: ${p => (p.cellWidth ? `${p.cellWidth * 2}px` : '100%')};
    left: calc(50% - ${p => (p.cellWidth ? `${p.cellWidth}px` : '100%')});
  }
`

const Social = styled.div`
  display: flex;
  margin-bottom: 1rem;
  font-size: 1.5rem;
`

const Title = styled.h1`
  font-weight: 700;
  ${mq({
    fontSize: ['1.75rem', '2rem'],
  })}
  margin: 0;
  margin-bottom: 0.5rem;
  line-height: 1;
  letter-spacing: -1px;
`

const Desc = styled.div`
  line-height: 1.35;
  font-size: 1rem;
  font-weight: 300;

  p {
    margin-bottom: 0.75em;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    display: inline-block;
    margin-top: 0.5rem;
    color: #fff;
    font-weight: 700;

    &:hover {
      opacity: 0.7;
    }
  }
`

const CellInner = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  box-shadow: inset 0 0 10rem ${rgba('#000', 0.25)};
  background: ${p => p.bgColor};
  background-image: linear-gradient(
    to bottom,
    ${p => adjustHue(30, p.bgColor)},
    ${p => p.bgColor},
    ${p => adjustHue(10, p.bgColor)}
  );

  ${mq({
    padding: ['0.5rem', '1rem', '2rem'],
  })}

  .gatsby-image-outer-wrapper {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &:hover {
    ${'' /* ${ImageWrapper} {
      transform: translateY(-10%);
    } */}

    ${Info} {
      opacity: 1;
      transform: scale(1);
    }

    ${ComingSoon} svg {
      transform: rotate(0);
    }

    ${VertTitle} {
      ${'' /* opacity: 0; */}
      transform: rotate(-90deg) translateY(-150px);
    }
  }
`

const VideoLink = styled.a`
  position: absolute;
  top: 0;
  right: 0;
  margin: 1rem;
  display: block;
  text-decoration: none;
  border: 1px solid;
  border-radius: 5px;
  background: none;
  color: #fff !important;
  padding: 0.2rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
